import React from 'react'
import ArrowIcon from '../icons/ArrowIcon'

type WatermarkSelectorProps = {
  displayValue: string
  onClick: () => void
  isActive?: boolean
}

const WatermarkSelector: React.FC<WatermarkSelectorProps> = ({
  displayValue,
  onClick,
  isActive = false
}) => (
  <div
    className={`pfv2-selector pfv2-selector--watermark ${
      isActive ? 'pfv2-selector--active' : ''
    }`}
    onClick={onClick}
  >
    <div
      className={`pfv2-selector-value pfv2-selector-value--watermark ${
        isActive ? 'pfv2-selector-value--active' : ''
      }`}
    >
      <span dangerouslySetInnerHTML={{ __html: displayValue }} />
    </div>
    <ArrowIcon isActive={isActive} />
  </div>
)

export default WatermarkSelector
